import { inject, Injectable, Injector } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BaseClass } from '../shared/class/BaseClass';
@Injectable({
  providedIn: 'root',
})
export class ToasterService extends BaseClass {
  private toastQueue: { severity: string; detail: string }[] = [];
  private isToastVisible = false;
  private toastLife = 2000; // Set the desired life for each toast message
  private messageService = inject(MessageService);
  constructor(injector: Injector) {
    super(injector);
  }

  private showNextToast(): void {
    if (this.toastQueue.length > 0 && !this.isToastVisible) {
      const toast = this.toastQueue.shift();
      if (toast) {
        this.isToastVisible = true;
        this.messageService.add({ ...toast, life: this.toastLife });
        setTimeout(() => {
          this.clearToast();
        }, this.toastLife);
      }
    }
  }

  public clearToast(): void {
    this.messageService.clear();
    this.isToastVisible = false;
    this.showNextToast();
  }

  private enqueueToast(severity: string, detail: string): void {
    this.toastQueue.push({ severity, detail });
    this.showNextToast();
  }

  showSuccess(message: string): void {
    this.enqueueToast('success', message);
  }

  showInfo(message: string): void {
    this.enqueueToast('info', message);
  }

  showWarning(message: string): void {
    this.enqueueToast('warn', message);
  }

  showError(message: string): void {
    this.enqueueToast('error', message);
  }
}
